module.exports = __webpack_public_path__ + "img/40_37_023_160.6b595a9b.jpg";